// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__2rQC3"};